const Years = [];

const current_year = new Date().getFullYear();

for( let i = current_year; i < current_year + 10; i++ )
{
    Years.push({
        'name': (i),
        'numeric': i
    });
}

export default Years;
